import qs from 'qs';
import type VueRouter from 'vue-router';
import removeIndexNameFromQuery from './removeIndexNameFromQuery';
import { QUERY_PARAMETER_JOINER, QUERY_PARAMETERS_STARTER } from '~~/constants/routes';
import { isSearchQueryParameter } from '~~/helpers/typesense/isSearchQueryParameter';

const getNonTypesenseQueryParameters = (
  queryParameters: Record<string, string | (string | null)[] | undefined>,
) => Object.entries(queryParameters).reduce(
  (accumulator: Record<string, string | (string | null)[] | undefined>, [queryLabel, queryValue]) => {

    if (!isSearchQueryParameter(queryLabel) && queryValue !== undefined) {

      accumulator[queryLabel] = queryValue;

    }

    return accumulator;

  },
  {},
);

const buildQueryString = (queryParts: string[]): string => {

  const nonEmptyQueryParts = queryParts.filter(Boolean);

  if (!nonEmptyQueryParts.length) {

    return '';

  }

  return `${QUERY_PARAMETERS_STARTER}${nonEmptyQueryParts.join(QUERY_PARAMETER_JOINER)}`;

};

export default (
  vueRouter: VueRouter,
  routeState: Record<string, any> | undefined,
  _isSSRMode: boolean,
  typesenseIndexName: string,
): string => {

  // safety: ensure routeState is an object
  routeState = routeState && typeof routeState === 'object' ? routeState : {};

  const queryParameters = vueRouter.currentRoute?.value?.query ?? {};
  const nonTypesenseQueryParameters = getNonTypesenseQueryParameters(queryParameters);

  routeState = removeIndexNameFromQuery(routeState, typesenseIndexName);

  const typesenseQueries = qs.stringify(routeState, { addQueryPrefix: false });
  const nonTypesenseQueries = qs.stringify(nonTypesenseQueryParameters, { addQueryPrefix: false });

  return buildQueryString([typesenseQueries, nonTypesenseQueries]);

};
